import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation(["footer", "common"]);
  const year = new Date().getFullYear();

  const footerLinks = [
    {
      title: t("footer:product"),
      links: [
        {
          label: t("footer:howItWorks"),
          href: "https://www.supervity.ai/autos#how-it-works",
          blank: true,
        },
        {
          label: t("footer:marketplace"),
          href: "/marketplace",
        },
        {
          label: t("footer:aiEmployees"),
          href: "https://www.supervity.ai/autos#ai-employees",
          blank: true,
        },
        {
          label: t("footer:pricing"),
          href: "/pricing",
        },
      ],
    },
    {
      title: t("footer:resources"),
      links: [
        {
          label: t("footer:documentation"),
          href: "/docs",
        },
        {
          label: t("footer:tutorials"),
          href: "/u/alpha/tutorials",
        },
        {
          label: t("footer:releaseNotes"),
          href: "/blog",
        },
      ],
    },
    {
      title: t("footer:company"),
      links: [
        {
          label: t("footer:supportContact"),
          href: "/support",
        },
        {
          label: t("footer:privacyPolicy"),
          href: "/privacy",
        },
        {
          label: t("footer:termsOfService"),
          href: "/tos",
        },
      ],
    },
  ];

  return (
    <footer className="w-full pt-10 relative border-t border-slate-100 bg-white dark:border-zinc-800 dark:bg-zinc-950">
      {/* <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `
        linear-gradient(to right, #e2e8f0 1px, transparent 1px),
        linear-gradient(to bottom, #e2e8f0 1px, transparent 1px)
      `,
          backgroundSize: "50px 60px",
          WebkitMaskImage:
            "radial-gradient(ellipse 90% 100% at 50% 100%, #000 60%, transparent 100%)",
          maskImage:
            "radial-gradient(ellipse 90% 100% at 50% 100%, #000 60%, transparent 100%)",
          opacity: 0.5,
        }}
      /> */}

      <div
        className="
    absolute inset-0 z-0
    [--grid-color:#e2e8f0]
    dark:[--grid-color:rgba(255,255,255,0.06)]
  "
        style={{
          backgroundImage: `
      linear-gradient(to right, var(--grid-color) 1px, transparent 1px),
      linear-gradient(to bottom, var(--grid-color) 1px, transparent 1px)
    `,
          backgroundSize: "50px 60px",
          WebkitMaskImage:
            "radial-gradient(ellipse 90% 100% at 50% 100%, #000 60%, transparent 100%)",
          maskImage:
            "radial-gradient(ellipse 90% 100% at 50% 100%, #000 60%, transparent 100%)",
          opacity: 0.5,
        }}
      />

      <div className="mx-auto relative z-20 flex max-w-7xl flex-col justify-between gap-16 px-6 lg:flex-row">
        <div className="max-w-sm">
          <a
            href="/"
            className="text-[28px] font-semibold tracking-tighter text-black dark:text-zinc-100"
          >
            {t("common:brandAuto")}
          </a>

          <p className="mt-6 text-base leading-[1.6] text-slate-600 dark:text-slate-400">
            {t("common:taglineFooter")}
            <br />
            {t("common:taglineFooterSub")}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-16 sm:grid-cols-3 lg:gap-24">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="mb-6 text-[13px] uppercase font-bold text-slate-400 dark:text-zinc-500">
                {group.title}
              </h3>

              <div className="flex flex-col gap-4">
                {group.links.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    target={link.blank ? "_blank" : undefined}
                    rel={link.blank ? "noopener noreferrer" : undefined}
                    className="text-[15px] font-medium text-[#4b5563] transition-colors hover:text-black dark:text-zinc-400 dark:hover:text-zinc-100"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mx-auto mt-10 relative z-20 max-w-7xl px-6 pt-5 pb-10">
        <p className="text-base text-slate-500 dark:text-zinc-500">
          {t("common:copyright", { year })}
        </p>
      </div>
    </footer>
  );
}
